/**
 * Sticky Nav — Menu de navegação por seções
 * Fica fixo ao scrollar e ativa o item correspondente à seção visível.
 */

export function initStickyNav() {
	const wrapper = document.querySelector('[data-sticky-nav]');
	if ( ! wrapper ) return;

	const nav = wrapper.querySelector('.sticky-nav');
	const items = wrapper.querySelectorAll('[data-sticky-nav-item]');
	if ( ! nav || ! items.length ) return;

	// ── Sticky behavior ─────────────────────────────
	let navOffsetTop = wrapper.offsetTop;
	let navHeight = nav.offsetHeight;
	let isStuck = false;

	function handleSticky() {
		navOffsetTop = isStuck ? wrapper.offsetTop : wrapper.offsetTop;
		navHeight = nav.offsetHeight;

		if ( window.scrollY >= navOffsetTop - 111 ) {
			if ( ! isStuck ) {
				isStuck = true;
				wrapper.classList.add('is-stuck');
				wrapper.style.paddingBottom = navHeight + 'px';
			}
		} else {
			if ( isStuck ) {
				isStuck = false;
				wrapper.classList.remove('is-stuck');
				wrapper.style.paddingBottom = '';
			}
		}
	}

	// ── Active section detection via IntersectionObserver ──
	// Apenas itens desktop para rastrear seções ativas
	const sections = [];
	wrapper.querySelectorAll('.sticky-nav__item[data-sticky-nav-item]').forEach( item => {
		const targetId = item.getAttribute('href').replace('#', '');
		const section = document.getElementById( targetId );
		if ( section ) sections.push({ item, section });
	});

	let setActive = function( activeItem ) {
		items.forEach( item => item.classList.remove('is-active') );
		if ( activeItem ) activeItem.classList.add('is-active');
	};

	// Detecção de seção ativa por scroll position
	function updateActiveByScroll() {
		const threshold = navHeight + 40;
		let activeMatch = null;
		sections.forEach( ({ item, section }) => {
			const top = section.getBoundingClientRect().top + window.scrollY;
			if ( top <= window.scrollY + threshold ) {
				activeMatch = item;
			}
		} );
		if ( activeMatch ) setActive( activeMatch );
	}

	if ( sections.length ) {
		window.addEventListener( 'scroll', updateActiveByScroll, { passive: true } );
		updateActiveByScroll();
	}

	// ── Mobile dropdown ─────────────────────────────
	const mobileSelect = wrapper.querySelector('[data-sticky-nav-select]');
	const mobileToggle = wrapper.querySelector('[data-sticky-nav-toggle]');
	const mobileValue  = wrapper.querySelector('.sticky-nav-mobile__value');

	if ( mobileToggle && mobileSelect ) {
		mobileToggle.addEventListener('click', () => {
			mobileSelect.classList.toggle('is-open');
		});

		// Fechar ao clicar fora
		document.addEventListener('click', ( e ) => {
			if ( ! mobileSelect.contains( e.target ) ) {
				mobileSelect.classList.remove('is-open');
			}
		});
	}

	function updateMobileValue( label ) {
		if ( mobileValue ) mobileValue.textContent = label;
	}

	// ── Smooth scroll on click ──────────────────────
	items.forEach( item => {
		item.addEventListener('click', ( e ) => {
			e.preventDefault();
			const targetId = item.getAttribute('href').replace('#', '');
			const section = document.getElementById( targetId );
			if ( ! section ) return;

			const offset = navHeight + 20;
			const top = section.getBoundingClientRect().top + window.scrollY - offset;

			window.scrollTo({ top, behavior: 'smooth' });
			setActive( item );

			// Atualiza mobile dropdown
			const label = item.textContent.trim();
			updateMobileValue( label );
			if ( mobileSelect ) mobileSelect.classList.remove('is-open');

			// Atualiza mobile options active
			const mobileOptions = wrapper.querySelectorAll('.sticky-nav-mobile__option');
			mobileOptions.forEach( opt => opt.classList.remove('is-active') );
			if ( item.classList.contains('sticky-nav-mobile__option') ) {
				item.classList.add('is-active');
			} else {
				// Sincroniza com a opção mobile correspondente
				mobileOptions.forEach( opt => {
					if ( opt.getAttribute('href') === item.getAttribute('href') ) {
						opt.classList.add('is-active');
					}
				});
			}
		});
	});

	// ── Sincronizar observer com mobile ─────────────
	const origSetActive = setActive;
	setActive = function( activeItem ) {
		origSetActive( activeItem );
		if ( activeItem ) {
			const label = activeItem.textContent.trim();
			updateMobileValue( label );
		}
	};

	// ── Recalculate on resize ───────────────────────
	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( () => {
			navHeight = nav.offsetHeight;
			if ( isStuck ) {
				wrapper.style.paddingBottom = navHeight + 'px';
			}
		}, 150 );
	});

	// ── Scroll listener ─────────────────────────────
	window.addEventListener('scroll', handleSticky, { passive: true });
	handleSticky();
}
